export default __webpack_public_path__ + "static/media/home-multiplayer.5c3925a8.png";